import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6588ab1c = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _a8eb15f6 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _fc92ec06 = () => interopDefault(import('../pages/apple-iphone-17-zubehoer.vue' /* webpackChunkName: "pages/apple-iphone-17-zubehoer" */))
const _f1e4e556 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _51ac9742 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _0a9603d6 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _e3933c52 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _2e7ffcca = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _1036d766 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _62d2eb5c = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _770dd1ee = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _1cbcfb56 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _68a1e374 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _1a915659 = () => interopDefault(import('../pages/sicherheit-und-einbruchschutz.vue' /* webpackChunkName: "pages/sicherheit-und-einbruchschutz" */))
const _49b3e42c = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _14430f04 = () => interopDefault(import('../pages/smarte-gemuetlichkeit.vue' /* webpackChunkName: "pages/smarte-gemuetlichkeit" */))
const _e1f70db6 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _4401b01c = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _32b777dd = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _4de0dc58 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _36a0ccd5 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _7620d03b = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _46db4f1f = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _84469280 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _6ebf5c4c = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _95717074 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _2a055422 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _18cbe3d8 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _72b04e05 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _2ae471e0 = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _64614a82 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _296ae9f1 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _a85560aa = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _0ef7df65 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _02ab1f4e = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _306c25a1 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _1a85734a = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _8e0cc538 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _990c6590 = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _759d4478 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _ec82a464 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _62cc9aae = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _2e97de49 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _6588ab1c,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _a8eb15f6,
    name: "anker"
  }, {
    path: "/apple-iphone-17-zubehoer",
    component: _fc92ec06,
    name: "apple-iphone-17-zubehoer"
  }, {
    path: "/google",
    component: _f1e4e556,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _51ac9742,
    name: "handyrechnung-aktion"
  }, {
    path: "/infos-zum-online-kauf",
    component: _0a9603d6,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _e3933c52,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _2e7ffcca,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _1036d766,
    name: "merkliste"
  }, {
    path: "/newsletter",
    component: _62d2eb5c,
    name: "newsletter"
  }, {
    path: "/panzerglass",
    component: _770dd1ee,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _1cbcfb56,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _68a1e374,
    name: "samsung"
  }, {
    path: "/sicherheit-und-einbruchschutz",
    component: _1a915659,
    name: "sicherheit-und-einbruchschutz"
  }, {
    path: "/smart-home-entdecken",
    component: _49b3e42c,
    name: "smart-home-entdecken"
  }, {
    path: "/smarte-gemuetlichkeit",
    component: _14430f04,
    name: "smarte-gemuetlichkeit"
  }, {
    path: "/soundcore",
    component: _e1f70db6,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _4401b01c,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _32b777dd,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _4de0dc58,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _36a0ccd5,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _7620d03b,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _46db4f1f,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _84469280,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _6ebf5c4c,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _95717074,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/samsung/product-data",
    component: _2a055422,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _18cbe3d8,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _72b04e05,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _2ae471e0,
    name: "shop-fehler"
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _64614a82,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _296ae9f1,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _a85560aa,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _0ef7df65,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _02ab1f4e,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _306c25a1,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _1a85734a,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _8e0cc538,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _990c6590,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _759d4478,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/shop/kundenformular/persoenliche-daten",
    component: _ec82a464,
    name: "shop-kundenformular-persoenliche-daten"
  }, {
    path: "/shop/kundenformular/zahlungsart",
    component: _62cc9aae,
    name: "shop-kundenformular-zahlungsart"
  }, {
    path: "/",
    component: _2e97de49,
    name: "index"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
